var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "messaging-analytics" },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        !_vm.loading && _vm.data && _vm.data.analytics
          ? _c("div", [
              _c("div", { staticClass: "toolbar" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewChart"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewChart') }",
                          },
                        ],
                        attrs: {
                          classNames: !_vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = false)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("insights")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsViewTable"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsViewTable') }",
                          },
                        ],
                        attrs: {
                          classNames: _vm.tableMode ? "selected" : "",
                          onClick: function () {
                            return (_vm.tableMode = true)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("table_view")])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "IconButton",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.$t(
                                "whatsapp_business_api.metaInsightsDownloadExcel"
                              ),
                            },
                            expression:
                              "{ content: $t('whatsapp_business_api.metaInsightsDownloadExcel') }",
                          },
                        ],
                        attrs: { onClick: _vm.exportToExcel },
                      },
                      [_c("md-icon", [_vm._v("download")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stats-row" },
                [
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalSent"
                      ),
                      value: _vm.totalSent,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsTotalDelivered"
                      ),
                      value: _vm.totalDelivered,
                      unit: _vm.$t(
                        "whatsapp_business_api.metaInsightsUnitMessage"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("StatCard", {
                    attrs: {
                      title: _vm.$t(
                        "whatsapp_business_api.metaInsightsDeliveryRate"
                      ),
                      value: _vm.deliveryRate,
                      unit: "%",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.tableMode
                ? _c(
                    "div",
                    { staticClass: "chart-container" },
                    [
                      _c("StackedAreaChart", {
                        attrs: {
                          title: _vm.$t(
                            "whatsapp_business_api.metaInsightsMessageStats"
                          ),
                          "x-axis-data": _vm.getXAxisData(),
                          legends: [
                            _vm.$t("whatsapp_business_api.metaInsightsSent"),
                            _vm.$t(
                              "whatsapp_business_api.metaInsightsDelivered"
                            ),
                          ],
                          colors: ["#37A2FF", "#80FFA5"],
                          series: _vm.getSeries(),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "table-container" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.tableData,
                          pagination: { pageSize: 10 },
                          size: "middle",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.data.analytics.country_codes &&
              _vm.data.analytics.country_codes.length > 0
                ? _c("div", { staticClass: "breakdown-section" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.metaInsightsCountryBreakdown"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "country-list" },
                      _vm._l(
                        _vm.data.analytics.country_codes,
                        function (country) {
                          return _c(
                            "div",
                            { key: country, staticClass: "country-item" },
                            [
                              _c("span", { staticClass: "country-code" }, [
                                _vm._v(_vm._s(country)),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ])
          : !_vm.loading
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: {
                    description: _vm.$t(
                      "whatsapp_business_api.metaInsightsNoData"
                    ),
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }